import { useEffect, useRef, useState } from "react";
import "./ImageZoom.css";
import { IMAGE_URL } from "../../Utils/constant";

const ImageZoom = ({ images = [] }) => {
  // Main view refs
  const imgRef = useRef(null);
  const lensRef = useRef(null);
  const resultRef = useRef(null);

  // Modal refs
  // const modalImgRef = useRef(null);
  // const modalLensRef = useRef(null);
  // const modalResultRef = useRef(null);

  const [activeImg, setActiveImg] = useState(images?.[0] || "");
  const [show, setShow] = useState(false); // main hover zoom
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [showModalZoom, setShowModalZoom] = useState(false); // modal hover zoom

  useEffect(() => {
    if (Array.isArray(images) && images.length > 0) setActiveImg(images[0]);
  }, [images]);

  // lock scroll when modal open
  useEffect(() => {
    if (!isModalOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, [isModalOpen]);

  const resetMainZoom = () => {
    setShow(false);
    if (resultRef.current) resultRef.current.style.backgroundImage = "none";
  };

  // const resetModalZoom = () => {
  //   setShowModalZoom(false);
  //   if (modalResultRef.current)
  //     modalResultRef.current.style.backgroundImage = "none";
  // };

  /* ---------------- MAIN (PAGE) LENS MOVE ---------------- */
  const moveLensMain = (e) => {
    const img = imgRef.current;
    const lens = lensRef.current;
    const result = resultRef.current;
    if (!img || !lens || !result) return;

    const rect = img.getBoundingClientRect();

    let x = e.clientX - rect.left - lens.offsetWidth / 2;
    let y = e.clientY - rect.top - lens.offsetHeight / 2;

    x = Math.max(0, Math.min(x, rect.width - lens.offsetWidth));
    y = Math.max(0, Math.min(y, rect.height - lens.offsetHeight));

    lens.style.left = `${x}px`;
    lens.style.top = `${y}px`;

    const cx = result.offsetWidth / lens.offsetWidth;
    const cy = result.offsetHeight / lens.offsetHeight;

    result.style.backgroundImage = `url(${IMAGE_URL}${activeImg})`;
    result.style.backgroundRepeat = "no-repeat";
    result.style.backgroundSize = `${rect.width * cx}px ${rect.height * cy}px`;
    result.style.backgroundPosition = `-${x * cx}px -${y * cy}px`;
  };

  /* ---------------- MODAL LENS MOVE (HOVER + TOUCH) ----------------
  const moveLensModal = (clientX, clientY) => {
    const img = modalImgRef.current;
    const lens = modalLensRef.current;
    const result = modalResultRef.current;
    if (!img || !lens || !result) return;

    const rect = img.getBoundingClientRect();

    let x = clientX - rect.left - lens.offsetWidth / 2;
    let y = clientY - rect.top - lens.offsetHeight / 2;

    x = Math.max(0, Math.min(x, rect.width - lens.offsetWidth));
    y = Math.max(0, Math.min(y, rect.height - lens.offsetHeight));

    lens.style.left = `${x}px`;
    lens.style.top = `${y}px`;

    const cx = result.offsetWidth / lens.offsetWidth;
    const cy = result.offsetHeight / lens.offsetHeight;

    result.style.backgroundImage = `url(${IMAGE_URL}${activeImg})`;
    result.style.backgroundRepeat = "no-repeat";
    result.style.backgroundSize = `${rect.width * cx}px ${rect.height * cy}px`;
    result.style.backgroundPosition = `-${x * cx}px -${y * cy}px`;
  };
  */
  const closeModal = () => {
    setIsModalOpen(false);
    // resetModalZoom(); // Disabled with modal area zoom.
  };

  return (
    <>
      {/* 320x520 container + thumbs always bottom (CSS) */}
      <div className="iz-container">
        {/* MAIN IMAGE + MAIN ZOOM RESULT */}
        <div className="iz-mainRow">
          <div
            className="img-container"
            // onMouseMove={(e) => {
            //   const img = imgRef.current;
            //   if (!img) return;
            //   setShow(true);
            //   moveLensMain(e);
            // }}
            // onMouseLeave={() => resetMainZoom()}
            onClick={() => setIsModalOpen(true)}
            style={{ cursor: "pointer" }}
          >
            <img ref={imgRef} src={`${IMAGE_URL}${activeImg}`} alt="zoom" />
            {show && (
              <div
                ref={lensRef}
                className="lens"
                style={{ pointerEvents: "none" }}
              />
            )}
          </div>

          {/* desktop zoom panel (optional; keep if you want) */}
          {show && <div ref={resultRef} className="result" />}
        </div>

        {/* THUMBNAILS ALWAYS DOWN */}
        <div className="iz-thumbsDown">
          {images.map((img, index) => (
            <button
              key={index}
              type="button"
              className={`iz-thumbBtn ${activeImg === img ? "active" : ""}`}
              onMouseEnter={() => {
                resetMainZoom();
                setActiveImg(img);
              }}
              onClick={() => {
                resetMainZoom();
                setActiveImg(img);
              }}
            >
              <img src={`${IMAGE_URL}${img}`} alt="" className="iz-thumbImg" />
            </button>
          ))}
        </div>
      </div>

      {/* MODAL OVERLAY: lens + zoom panel INSIDE MODAL */}
      {isModalOpen && (
        <div className="iz-modalOverlay" onClick={closeModal}>
          <button className="iz-closeBtn" onClick={closeModal} type="button">
            ×
          </button>

          <div className="iz-modalShell" onClick={(e) => e.stopPropagation()}>
            {/* LEFT: modal image with lens */}
            <div
              className="iz-modalImgWrap"
              // Modal area zoom disabled; keep handlers for future reuse.
              // onMouseEnter={() => setShowModalZoom(true)}
              // onMouseLeave={() => resetModalZoom()}
              // onMouseMove={(e) => {
              //   setShowModalZoom(true);
              //   moveLensModal(e.clientX, e.clientY);
              // }}
              // onTouchStart={() => setShowModalZoom(true)}
              // onTouchMove={(e) => {
              //   const t = e.touches?.[0];
              //   if (!t) return;
              //   setShowModalZoom(true);
              //   moveLensModal(t.clientX, t.clientY);
              // }}
              // onTouchEnd={() => resetModalZoom()}
            >
              <img
                // ref={modalImgRef}
                src={`${IMAGE_URL}${activeImg}`}
                alt="large view"
                className="iz-modalImg"
                draggable="false"
              />
              {/* Modal zoom lens disabled; keep for future reuse.
              {showModalZoom && (
                <div
                  ref={modalLensRef}
                  className="lens lens--modal"
                  style={{ pointerEvents: "none" }}
                />
              )}
              */}
            </div>

            {/* RIGHT: zoomed panel disabled; keep for future reuse.
            <div
              ref={modalResultRef}
              className={`iz-modalResult ${showModalZoom ? "is-visible" : ""
                }`}
            />
            */}
          </div>
        </div>
      )}
    </>
  );
};

export default ImageZoom;
